<template>
  <div class="hello">
    <div ref="mychart" :style="{ height: height, width: width }"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "LaifangChart",
  props: {
      width: {
          type: String,
          default: '430px'
      },
      height: {
          type: String,
          default: '258px'
      },
      dataList:{
          type: Array,
          default: () => []
      }
  },
  data() {
      return {
          chart: null
      }
  },
  watch: {
      dataList(){
          this.initChart()
      }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.mychart);
      this.chart.setOption({
        grid:{
          top: 30, right: 30, bottom: 40, left: 45,
        },
        xAxis: {
          type: 'category',
          data: this.dataList.map(obj => (obj.date)),
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            color: '#fff',
            fontSize: 10,
            lineHeight: 13,
            align: 'center',
            formatter: function (value) {
              return value.length > 5  ? value.replace(/(.{5})/g, '$1\n').trim() : value;
            },
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            formatter: function (value) {
              if (value % 1 === 0) {
                return value;
              }
              return '';
            }
          },
          splitLine: {
            lineStyle: {
              color: ['rgba(51, 161, 218, 0.15)'],
              type: 'dashed'
            }
          }
        },
        series: [
          {
            data: this.dataList.map(obj => (obj.num)),
            type: 'line',
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#031742f0',
              borderColor: '#00C0FF',
              borderWidth: 2,
            },
            label: {
              show: true,
              position: 'top',
              color: '#fff'
            },
            lineStyle: {
              color: '#00C0FF',
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#00C0FF' },
                { offset: 1, color: '#00FFFF00' }
              ])
            }
          }
        ]
      })
    },
  },
}
</script>
<style scoped></style>